var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSktr1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#1D1D1D",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 7)",
    strokeWidth: 2.095
  }, /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.474,
    stroke: "#FFF",
    x: 11.588,
    y: 32.476,
    width: 15.824,
    height: 3.143,
    rx: 1.571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.838 27.238c1.746 0 3.162 1.126 3.162 2.514v11.734C39 42.874 37.584 44 35.838 44h-3.162c-1.747 0-3.162-1.126-3.162-2.514V39.81H9.486v1.676C9.486 42.874 8.071 44 6.324 44H3.162C1.416 44 0 42.874 0 41.486V29.752c0-1.388 1.416-2.514 3.162-2.514",
    strokeOpacity: 0.474,
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#32C5FF",
    strokeLinecap: "square",
    d: "M12.122 27.238h14.756"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#32C5FF",
    cx: 31.622,
    cy: 27.238,
    rx: 3.169,
    ry: 3.143
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.622 24.619 26.706 1.657A2.095 2.095 0 0 0 24.657 0h-1.472",
    stroke: "#32C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.375 24.619 12.29 1.657A2.095 2.095 0 0 1 14.34 0h8.85",
    strokeOpacity: 0.474,
    stroke: "#FFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#32C5FF",
    cx: 7.378,
    cy: 27.238,
    rx: 3.169,
    ry: 3.143
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSktr1);
export default __webpack_public_path__ + "static/media/sktr1.e229ad386a2e2ec191fc7483b9b9ef08.svg";
export { ForwardRef as ReactComponent };